import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';

import { SessionStorageService } from "../shared/services/session-storage.service";

@Component({
    template: require('./notFound.component.html'),
    styles: [require('./notFound.component.less')],
    preserveWhitespaces: true
})

export class NotFoundComponent implements OnInit, OnDestroy {
    isPatientAppView: boolean = false;

    constructor(
        private _router: Router,
        private _sessionStorageService: SessionStorageService
    ) { }

    goHome = () => {
        this._router.navigate(['/login']);
    }

    ngOnInit() {
        this._sessionStorageService.readItem('patientAppView').then(
            (isPatientAppView: any) => {
                this.isPatientAppView = isPatientAppView;
            });

        setTimeout(() => {
            document
                .querySelector("body")
                .classList.add("body-not-found");
        });
    }

    ngOnDestroy() {
        document
            .querySelector("body")
            .classList.remove("body-not-found");
    }
}
